import {
    Column,
    GridContainer,
    ModalDialog,
    ModalDialogBody,
    ModalDialogCloseButton,
    ModalDialogContent,
    ModalDialogHeader,
    ModalDialogNav,
    ModalDialogTitle,
    Row,
} from '@vp/swan';
import styled from 'styled-components';
import { __ } from '@99designs/i18n';
import { OptionDescription } from './OptionDescription';
import { OptionsData } from './OptionsData';

const StyledModalDialogContent = styled(ModalDialogContent)`
    max-width: 800px;
`;

export type OptionsDialogProps = {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
};

export function OptionsDialog({ isOpen, setIsOpen }: OptionsDialogProps) {
    return (
        <ModalDialog
            variant="panel-right"
            bodyWidth="grow"
            isOpen={isOpen}
            onRequestDismiss={() => setIsOpen(false)}
        >
            <StyledModalDialogContent aria-labelledby="modal dialog panel">
                <ModalDialogNav>
                    <ModalDialogCloseButton accessibleText={__('Close')} />
                </ModalDialogNav>
                <ModalDialogHeader>
                    <ModalDialogTitle>
                        {__('Choose a review method that works for you')}
                    </ModalDialogTitle>
                </ModalDialogHeader>
                <ModalDialogBody>
                    <GridContainer>
                        <Row>
                            <Column key="DesignLive" span={6}>
                                <OptionDescription {...OptionsData('DesignLive')} />
                            </Column>
                            <Column key="Standard" span={6}>
                                <OptionDescription {...OptionsData('Standard')} />
                            </Column>
                        </Row>
                    </GridContainer>
                </ModalDialogBody>
            </StyledModalDialogContent>
        </ModalDialog>
    );
}
